import { parseISO, format, isValid } from 'date-fns'

function toDate (value) {
  if (!value) return null
  if (Object.prototype.toString.call(value) === '[object Date]') return value
  return parseISO(value)
}

const install = function (Vue, options) {
  Vue.prototype.$formatDate = function (value) {
    const d = toDate(value)
    if (!d || !isValid(d)) return 'N/A'
    return format(d, 'MM/dd/yyyy')
  }

  Vue.prototype.$formatDateTime = function (value) {
    const d = toDate(value)
    if (!d || !isValid(d)) return 'N/A'
    return format(d, 'MM/dd/y h:mma')
  }

  Vue.prototype.$formatDateTimeMilliseconds = function (value) {
    const d = toDate(value)
    if (!d || !isValid(d)) return 'N/A'
    return format(d, 'MM/dd/y h:mm:ss.SSSa')
  }

  Vue.prototype.$qalert = function (json) {
    alert(JSON.stringify(json, null, 2))
  }
}

const FnbHelpersPlugin = {
  install: install
}

export { FnbHelpersPlugin }
